/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import TextInput from "../BasicInputs/TextInput.jsx";
import {Database} from "../../APIClient.jsx";
import OutputList from "../OutputList/OutputList.jsx";
import OutputListItem from "../OutputList/OutputListItem.jsx";
import {Util} from "../../Utilities.js";
import ElementDomains from "../ElementDomains.jsx";
import ButtonComponent from "../BasicInputs/ButtonComponent.jsx";
import {names} from "../../Constants.js";
import {Services} from "../../Objects/Services.jsx";

class ServiceSettings extends Component {
    constructor() {
        super();

        this.state = {
            serviceInfo: {}
        }
        this.DebouncedSave = Util.performance.debounce((handler, query) => handler(query), 300)

    }


    async fetchData() {
        let {serviceId} = this.props
        let service = await Database.table("Services", "app").simpleFilter("indexKey", serviceId)
        this.setState({serviceInfo: service?.recordset?.[0] ?? {}})

    }

    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.serviceId !== this.props.serviceId) {
            this.fetchData()
        }
    }

    onChange(key, value) {
        let {serviceInfo} = this.state

        this.setState((state) => {
            let newData = state.serviceInfo
            newData[key] = value
            return ({serviceInfo: newData})
        }, () => {
            this.DebouncedSave(() => {
                Services(serviceInfo.indexKey).update({[key]: this.state.serviceInfo?.[key]})
            })

        })


    }


    render() {
        let {serviceInfo} = this.state
        return (
            <div className={"py-2"}>
                <OutputList>
                    <OutputListItem titel={`${names.service} Id`}>
                        <span>{serviceInfo.indexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={`${names.service} Name`}>
                        <span>{serviceInfo.serviceName}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Image Id"}>
                        <span>{serviceInfo.imageIndexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Address"}>
                        <span>{serviceInfo.domain}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Node Id"}>
                        <span>{serviceInfo.nodeIndexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={"Background"}>
                        <span>
                            <TextInput value={(serviceInfo?.backgroundURL ?? "").toString()} onChange={(newValue) => {
                                this.onChange("backgroundURL", newValue)
                            }}/>
                        </span>
                    </OutputListItem>

                    {Object.keys((serviceInfo?.settings ?? {})).map(key => {

                        return <OutputListItem titel={`${key}`}>
                            <TextInput value={(serviceInfo?.settings?.[key] ?? "").toString()} onChange={(newValue) => {
                                this.onChange(key, newValue)
                            }}/>
                        </OutputListItem>

                    })}

                    <OutputListItem titel={"Domains"}>
                        <span>
                                       <ElementDomains elementId={serviceInfo.indexKey} elementType={"container"}/>

                        </span>
                    </OutputListItem>
                    <OutputListItem titel={""}>
                        <ButtonComponent
                            text={`Remove ${names.service}`}
                            onClick={async () => {
                                await Services(serviceInfo.indexKey).remove()

                            }}></ButtonComponent>
                    </OutputListItem>
                </OutputList>

            </div>
        );
    }
}

ServiceSettings.propTypes = {};

ServiceSettings.defaultProps = {};


export default ServiceSettings;